export default __webpack_public_path__ + "static/media/logo-clover.12188f2e.png";